























import { Prop, Component, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class ScoreBar extends Vue {
  @Prop() private score!: number;
  private color: string = "red";
  private created() {
    if (this.score >= 85) {
      this.color = "green";
    } else if (this.score >= 70) {
      this.color = "yellow";
    }
  }
}
